import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { liVariants } from "./Li.variants.js";
const Li_Li = /*#__PURE__*/ forwardRef(function({ className, children, ...props }, ref) {
    const classes = cn(liVariants(props), className);
    const domProps = cleanProps(props, Object.keys(liVariants.variants));
    return /*#__PURE__*/ jsx("li", {
        ref: ref,
        className: classes,
        ...domProps,
        children: children
    });
});
export { Li_Li as Li };
